import React, { useState, useEffect } from "react";
import Benner from "./main/Benner";
import InquiryPopup from "./main/InquiryPopup";
import AboutSection from "./main/AboutSection";
import IntroSection from "./main/IntroSection";

import CourseGrid from "./ui/CourseGrid";

const Home = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Auto-open popup after 10 seconds
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 4000);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Benner />

      {/* Popup is displayed only when showPopup is true */}
      {showPopup && <InquiryPopup onClose={() => setShowPopup(false)} />}

      <AboutSection />
      <IntroSection />
      <CourseGrid />
    </>
  );
};

export default Home;
